import React from 'react';
import 'font-awesome/css/font-awesome.min.css';
import './ApBooking.css';
import { useLocale } from '../context/LocaleContext';
import { useBookAppointmentModal } from '../context/BookAppointmentModalContext';

const ApBooking = () => {
  const { t } = useLocale();
  const { openBookAppointmentModal } = useBookAppointmentModal();

  return (
    <button
      type="button"
      className="sticky_container"
      aria-label={t('stickyBook')}
      onClick={openBookAppointmentModal}
    >
      <i className="fa fa-calendar sticky_container_icon" aria-hidden="true" />
      <span className="sticky_container_text">{t('stickyBook')}</span>
    </button>
  );
};

export default ApBooking;
